import { RawProjectLineItem } from "./line-item";

export class CartSubmitData {
  public constructor(
    input: {
      productVariantId: string;
      projectId: string;
      checks: {
        approved: boolean;
        approvalMethod: string;
      };
      lineItem: RawProjectLineItem;
      returnToEditUrl: string;
    },
    additional: Record<string, any>,
  ) {
    this.id = input.productVariantId;
    (this.quantity = input.lineItem.quantity),
      (this.properties = {
        _projectId: input.projectId,
        _approved: input.checks.approved,
        _approvalMethod: input.checks.approvalMethod,
        _quantity: input.lineItem.quantity,
        _itemId: input.lineItem.key,
        _returnToEditorUrl: input.returnToEditUrl || null,
      });
    if (additional) {
      this.properties = Object.assign(this.properties, additional);
    }
  }
  id: string;
  quantity: number;
  properties: object;
}
